export default __webpack_public_path__ + "static/media/thirdPartyDataBreachIncident.edb2ce32.svg";